const CoupanCityParser = {};

CoupanCityParser.getCouponParser = (res) => {
  if (res) {
    res = res.result.reverse();
  }

  if (!res) {
    return {};
  }
};

export { CoupanCityParser };
